module.exports = __webpack_public_path__ + "src/assets/img/artic_truck.a0edfce6.svg";